/*
* @Author: yongwenhao
* @Date: 2020-04-09 16:25:39
* @describe: 新闻列表
*/
<template>
    <div class='item-warp'>
        <div class="content-wrap" id="contentWrap">
            <ElRow>
                <template v-for="item in dataList">
                    <ElCol :xs="{span:24}" :sm="24" :md="24" :lg="24" :xl="24" class="news-item">
                        <!-- <img class="avatar" :src="item.imageThumbUrl"> -->
                        <div class="news-wrap" @click="goNewsItem(item)">
                            <p class="title"><span>{{title}} — </span>{{item.title}}</p>
                            <p>{{item.publishDate | dateFilter}}</p>
                        </div>
                    </ElCol>
                </template>
            </ElRow>
        </div>
        <div style="text-align: center">
            <i class="el-icon-loading" v-show="loading"></i>
        </div>
    </div>
</template>

<script>
    import moment from "moment"
    import {throttle} from "throttle-debounce";

    export default {
        name: "item-warp",
        props: {
            title: {
                type: String,
                default: ''
            },
            dataList: {
                type: Array,
                default: () => {
                    return []
                }
            },
            loading: Boolean
        },
        data() {
            return {}
        },
        mounted() {
            this.throttledScrollHandler = throttle(300, this.onScroll);
            window.addEventListener('scroll', this.onScroll);
        },
        methods: {
            goNewsItem(item) {
                this.$router.push({name: "WEB", query: {newsId: item.newsId}});
            },
            onScroll() {
                // let scrollTop = document.getElementById("mainWrap").scrollTop+document.body.clientHeight;
                // let clientHeight = this.$el.parentElement.clientHeight;
                // if (scrollTop > clientHeight) {
                //     this.$emit("onScrollBottom")
                // }
                const scrollY = window.scrollY;
                const windowHeight = window.innerHeight;
                const documentHeight = document.documentElement.scrollHeight;
                const bottomOfPage = windowHeight + scrollY >= documentHeight;
                if (bottomOfPage) {
                    this.$emit("onScrollBottom")
                }
            }
        },
        filters: {
            dateFilter(date) {
                return date ? moment(date).format("YYYY/MM/DD") : ""
            }
        }
    }
</script>

<style lang='less' scoped>
    @import "../../../style/constant";

    .item-warp {
        // max-width: @page-width;
        max-width: 792px;
        margin: 100px auto;
        margin-top: 60px;
        .news-item {
            display: flex;
            align-items: center;
            margin: 10px 0;
            color: @title-color;

            &:hover .title {
                color: @primary-color;
                cursor: pointer;
            }

            .avatar {
                width: 65px;
                height: 65px;
                object-fit: cover;
                border-radius: 50%;
                flex-shrink: 0;
                border: 1px solid #435ba1;
            }

            .news-wrap {
                flex: 1;
                overflow: hidden;
                padding-left: 15px;

                .title {
                    font-size: 20px;
                    font-weight: 500;
                    width: 100%;
                    // overflow: hidden;
                    // text-overflow: ellipsis;
                    // white-space: nowrap;
                }

            }
        }

        @media screen and (min-width: 320px) and (max-width: 480px) {
            .news-item {
                margin: 10px 0;
            }
        }
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
        .item-warp {
            max-width: 90%;
            margin: 50px auto;
        }
    }
</style>
